/**
 * Die Header, in denen Berechtigungen stehen.
 *
 * **Vier Namen, eine Stelle.** Sie standen bis Zyklus 10d im Server (`auth/admin.ts`,
 * `auth/game-access.ts`) — richtig, solange nur der Server sie kannte. Mit der Admin-Oberfläche
 * schreibt der Browser sie ebenfalls, und ab 10e kommen Host-, Einladungs- und Sitzungs-Token
 * dazu. Ein Headername, der an zwei Stellen geschrieben wird, ist ein Vertrag mit zwei Quellen;
 * laufen sie auseinander, antwortet der Dienst „nicht berechtigt" und niemand sucht den
 * Tippfehler. Deshalb gehören sie hierher, wie jedes andere Format (`CLAUDE.md` Regel 7).
 *
 * **Durchgehend klein geschrieben, und das ist geprüft.** Node kleinschreibt eingehende
 * Headernamen; `request.headers['X-Admin-Key']` ist immer `undefined`. Ein Konstante mit
 * Großbuchstaben würde also jeden Zugang still verweigern — ein Fehler, der nach einem falschen
 * Schlüssel aussieht.
 *
 * **Berechtigungen stehen nie in einer Adresse.** Ein Pfad landet im Zugriffslog von nginx und
 * im `Referer`; ein Header tut beides nicht (`CLAUDE.md`, Security by Design, und
 * `docs/ARCHITECTURE.md` **E26**).
 */
/** Der Admin-Schlüssel — globale Regeln, Host-Links, ab Phase 11 der Debug-Modus. */
export const ADMIN_KEY_HEADER = 'x-admin-key';
/** Ein Host-Token — eine Partie anlegen. Wiederverwendbar, nicht an eine Partie gebunden. */
export const HOST_TOKEN_HEADER = 'x-host-token';
/** Ein Invite-Token — einem freien Farbslot einer konkreten Partie beitreten. */
export const INVITE_TOKEN_HEADER = 'x-invite-token';
/** Ein Sitzungs-Token — als dieser Spieler handeln (§46, Reconnect). */
export const SESSION_TOKEN_HEADER = 'x-session-token';
/**
 * Alle vier als Laufzeitliste.
 *
 * Nicht nur Bequemlichkeit: eine Prüfung über **alle** Header (Schreibweise, Eindeutigkeit)
 * braucht die Liste, und eine Prüfung, die eine Kopie der Namen enthält, prüft sich selbst.
 * Dasselbe Muster wie `API_ERROR_CODES` und `PIECE_TYPES`.
 */
export const AUTH_HEADERS = [
    ADMIN_KEY_HEADER,
    HOST_TOKEN_HEADER,
    INVITE_TOKEN_HEADER,
    SESSION_TOKEN_HEADER,
];
//# sourceMappingURL=headers.js.map